import {
  IWidgetSubmitStatus,
  WidgetConsentsType,
  WidgetConsentSubmitStatus,
  WidgetContactFormSubmitStatus
} from 'widget/entities/config';

export const DEFAULT_SUBMIT_STATUSES: IWidgetSubmitStatus = {
  contactForm: WidgetContactFormSubmitStatus.pending,
  personalDataConsent: WidgetConsentSubmitStatus.pending,
  mailingConsent: WidgetConsentSubmitStatus.pending
};

/** Дефолтные начальные значения чекбоксов согласий */
export const DEFAULT_CONSENT_CHECKBOX_VALUES: Record<
  WidgetConsentsType,
  boolean
> = {
  [WidgetConsentsType.personalData]: false,
  [WidgetConsentsType.mailing]: false
};
